import { createMutableAction } from '@bimser/core';
import * as ActionTypes from '../actionTypes';
import { IUpdateVirtualScrollingOptions } from '../entities/payloads/IUpdateVirtualScrollingOptions';

export const updateVirtualScrollingOptions = (payload: IUpdateVirtualScrollingOptions) =>
	createMutableAction(ActionTypes.UPDATE_VIRTUAL_SCROLLING_OPTIONS, payload);
